import React, { Suspense, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { Panel } from 'react-bootstrap';
import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';
import { navigate } from 'raviger';

import { useAlertStore } from '../../store/providers/Alert';
import { useGmailGroupStore } from '../../store/providers/GmailGroups';
import Permission from '../../components/Permission/Permission';
import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import Spinner from '../../components/Spinner/Spinner';

import * as constants from '../../constants';
import { columns, sorting } from './GmailGroupsListSchema';
import DocumentSetupList from '../../components/Lists/DocumentSetupList/DocumentSetupList';
const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));
const GmailGroupModal = React.lazy(() => import('../../components/Modals/GmailGroupModal/GmailGroupModal'));


function GmailGroups() {
    const dispatch = useDispatch();
    const { addAlert } = useAlertStore();
    const { selectRecord, listRecords, newRecord, deleteRecord, data, clearData } = useGmailGroupStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [listData, setListData] = useState([]);

    const pagePermission = constants.PERMISSION_SETTINGS_GmailGroups;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const selectedHandler = (gmailGroup) => {
        setIsEditing(true);
        selectRecord({ groupId: gmailGroup.id });
    };

    const addedHandler = () => {
        setIsEditing(true);
        newRecord();
    };

    const cancelledHandler = () => {
        setIsEditing(false);
    };

    const submittedHandler = () => {
        setIsEditing(false);
        listRecords();
    };

    const deletedHandler = (group) => {
        deleteRecord({ groupId: group.id });
    };

    const refreshedHandler = () => {
        listRecords();
    };

    const viewMembersPageHandler = (group) => {
        if (group && group.id) {
            navigate(`/members/${group.id}`);
        }
    };

    useEffect(() => {
        if (!_.isEmpty(data)) {

            if (data.status === 'fail' || data.status === 'error') {
                addAlert({ key: constants.ALERT_SERVER_ERROR, text: <strong>{data.body}</strong>, type: constants.ALERT_TYPE_DANGER });
                clearData();
            }

            if (data.scope === 'delete' && data.status === 'success') {
                listRecords();
            }

            if (data.status === 'success' && data.scope === 'list') {
                setListData(data.body);
            }

            setIsBusy(data.status === 'processing' && (data.scope === 'delete' || data.scope === 'list'));
        }
    }, [data, addAlert, clearData, listRecords]);


    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) { return; }
        dispatch(breadcrumbAddRoute({ key: 'gmailGroups', parent: 'Settings', text: 'Gmail Groups', path: '/gmailGroups' }));
        listRecords();

        setIsMounted(true);
    }, [isMounted, hasPermission, listRecords, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    return (
        <>
            <SideMenu activeKey="settings" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
                {hasPermission && isMounted &&
                    <Suspense fallback={<Spinner text="Loading..." />}>
                        {
                            isEditing && <GmailGroupModal
                                show={isEditing}
                                canEdit={canEdit}
                                title={(!_.isEmpty(data) && !_.isEmpty(data.body)) ? 'Edit Gmail Group' : 'Add Gmail Group'}
                                cancelled={() => cancelledHandler()}
                                submitted={() => submittedHandler()} />
                        }
                        <div style={{ paddingRight: '15px' }}>
                            <PageHeader title="Gmail Groups" />
                            <Panel>
                                <Panel.Body>
                                    <DocumentSetupList
                                        compType="Gmail Group"
                                        listData={listData}
                                        isBusy={isBusy}
                                        sorting={sorting}
                                        columns={columns}
                                        hideCopy={true}
                                        hidePrint={true}
                                        hideFilter={true}
                                        hideMembersPage={false}
                                        permissionEdit={canEdit}
                                        added={() => addedHandler()}
                                        selected={(gmailGroup) => selectedHandler(gmailGroup)}
                                        deleted={(gmailGroup) => deletedHandler(gmailGroup)}
                                        viewMembersPage={(gmailGroup) => viewMembersPageHandler(gmailGroup)}
                                        refreshed={() => refreshedHandler()} />
                                </Panel.Body>
                            </Panel>
                        </div>
                    </Suspense>
                }
            </div>
        </>
    );
}
export default withAuthentication(withLayout(GmailGroups));





